import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCallRecordLocalStore = defineStore('call-record-local', () => {
  const streams = ref<{ [key: string]: MediaRecorder }>({})
  const recordingSubscribersByRoomPServed = ref<Map<string, Set<string>>>(new Map())

  const removeRecorder = (recorder: MediaRecorder) => {
    const key = Object.keys(streams.value).find((key) => streams.value[key] === recorder)
    if (key) {
      delete streams.value[key]
    }
  }

  const getRecorderBySession = (id: string) => {
    const recorder = streams.value[id]
    if (recorder && recorder.state !== 'recording') {
      removeRecorder(recorder)
      return undefined
    }

    return recorder
  }

  const addRecorder = (id: string, recorder: MediaRecorder) => {
    streams.value[id] = recorder
  }

  const addRecordingSubscriber = (pServed: string, subscriberPServed: string) => {
    const pServeds = recordingSubscribersByRoomPServed.value.get(pServed)
    if (!pServeds) {
      recordingSubscribersByRoomPServed.value.set(pServed, new Set([subscriberPServed]))
    } else {
      pServeds.add(subscriberPServed)
    }
  }

  const removeRecordingSubscriber = (pServed: string, subscriberPServed: string) => {
    recordingSubscribersByRoomPServed.value.get(pServed)?.delete(subscriberPServed)
  }

  const clearRecordingSubscribersByRoomPServed = (pServed: string) => {
    recordingSubscribersByRoomPServed.value.delete(pServed)
  }

  return {
    recordingSubscribersByRoomPServed,
    getRecorderBySession,
    addRecorder,
    removeRecorder,
    addRecordingSubscriber,
    removeRecordingSubscriber,
    clearRecordingSubscribersByRoomPServed,
  }
})
